import React from "react";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

function ArticleContent() {
    return (
        <MKBox component="section" py={4} mb={8}>
            <Container>
                <Grid container spacing={3} justifyContent="center">
                    <Grid item xs={12} lg={10}>
                        <MKTypography variant="h2" mb={3} color="dark">
                            Curățare profesională pentru geamuri și suprafețe vitrate
                        </MKTypography>

                        <MKTypography variant="body1" color="text" mb={2}>
                            Curățarea sticlei și a tâmplăriei este o artă. Nu exagerăm când spunem
                            asta – fiecare suprafață are particularitățile ei, fiecare tip de
                            murdărie cere o altă abordare.
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={4}>
                            La Doral Cleaning facem asta zilnic, pentru apartamente, birouri și hale
                            industriale, cu tehnici și produse profesionale care nu lasă urme și nu
                            pun sticla în pericol.
                        </MKTypography>

                        <MKBox
                            component="img"
                            src="https://i.ibb.co/q3nVGdcS/curetenie-geamuri-dupa-constructie.jpg"
                            alt="curățare geamuri profesional Doral Cleaning"
                            width="100%"
                            borderRadius="xl"
                            shadow="md"
                            mb={4}
                        />

                        <MKTypography variant="h3" mb={3} color="dark">
                            Avantajele colaborării cu o firmă de curățare geamuri profesională
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={2}>
                            Spălarea ferestrelor arată simplu până când dai de o suprafață mare, de
                            murdărie aderentă sau de o tâmplărie din material sensibil. Atunci
                            contează cu cine lucrezi. Noi evaluăm mai întâi tipul de sticlă și
                            natura depunerilor, apoi alegem metoda potrivită – raclete profesionale,
                            ustensile de finisare, soluții premium. Niciun burete de vase, niciun
                            produs universal de supermarket.
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={4}>
                            Diferența se vede imediat și se simte pe termen lung, fie că vorbim de{" "}
                            <a
                                href="https://doral-cleaning.ro/curatenie-vile-apartamente"
                                style={{
                                    textDecoration: "none",
                                    color: "#1A73E8",
                                    fontWeight: "bold",
                                }}
                            >
                                curățenie la o vilă sau apartament
                            </a>
                            , fie de o clădire de birouri.
                        </MKTypography>

                        <MKBox
                            component="img"
                            src="https://doral-cleaning.ro/static/media/9-1-vitrate.706d0ff0aa7ab503bdad.webp"
                            alt="angajat Doral Cleaning care curata geamurile"
                            width="100%"
                            borderRadius="xl"
                            shadow="md"
                            mb={4}
                        />

                        <MKTypography variant="h3" mb={3} color="dark">
                            Spălarea geamurilor la apartamente și balcoane – soluții pentru acasă
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={2}>
                            La curățarea de întreținere, acolo unde avem de-a face cu murdărie
                            neaderentă, lucrăm cu dispozitive telescopice, raclete profesionale și
                            soluții care nu lasă dâre.
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={2}>
                            Curățăm geamurile complet, la interior și exterior, inclusiv termopan și
                            compartimentări vitrate. Dacă ești interesat de un{" "}
                            <a
                                href="https://doral-cleaning.ro/curatenie-vile-apartamente"
                                style={{
                                    textDecoration: "none",
                                    color: "#1A73E8",
                                    fontWeight: "bold",
                                }}
                            >
                                serviciu complet de curățenie pentru vila sau apartamentul tău
                            </a>
                            , acolo găsești toate detaliile.
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={4}>
                            Acolo unde murdăria e mai îndărătnică sau suprafața are nevoie de
                            igienizare suplimentară, folosim și curățare cu aburi.
                        </MKTypography>

                        <MKTypography variant="h4" mb={2} color="dark">
                            Curățarea geamurilor de balcon la interior și exterior
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={4}>
                            Lucrăm pe orice tip de balcon – tâmplărie culisantă sau fixă, lungă sau
                            îngustă – și curățăm sticla pe ambele fețe. Folosim soluții care resping
                            praful după intervenție, astfel că transparența se menține mai mult față
                            de o spălare obișnuită.
                        </MKTypography>

                        <MKBox
                            component="img"
                            src="https://doral-cleaning.ro/static/media/9-4-vitrate.95bdd4a88942a248a337.webp"
                            alt="curatare geamuri balcon fixe la interior și exterior"
                            width="100%"
                            borderRadius="xl"
                            shadow="md"
                            mb={4}
                        />

                        <MKTypography variant="h3" mb={3} color="dark">
                            Atenție la detalii: curățare chedere geamuri și tâmplărie PVC
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={2}>
                            Geamul poate ieși impecabil, dar dacă chedrele și profilurile sunt
                            neglijate, rezultatul tot nu e complet. Murdăria se acumulează în locuri
                            greu de ajuns, iar tâmplăria din PVC, aluminiu sau lemn se poate
                            deteriora rapid dacă folosești produse nepotrivite.
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={4}>
                            Noi lucrăm cu soluții dedicate fiecărui material, fără abrazive, fără
                            acizi care atacă garniturile sau mecanismele de închidere. Ce pare un
                            detaliu minor poate deveni un defect permanent dacă e tratat la
                            întâmplare.
                        </MKTypography>

                        <MKTypography variant="h4" mb={2} color="dark">
                            Îndepărtarea urmelor de materiale după constructor
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={2}>
                            Vopsea, ciment, spumă poliuretanică, adeziv – după orice renovare rămân
                            pe geamuri urme care nu ies cu o simplă spălare. Le îndepărtăm manual,
                            cu răzuitoare profesionale și produse specifice fiecărui tip de
                            material.
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={2}>
                            Dacă tocmai ai terminat o renovare, vezi și serviciul nostru de{" "}
                            <a
                                href="https://doral-cleaning.ro/curatenie-post-construct"
                                style={{
                                    textDecoration: "none",
                                    color: "#1A73E8",
                                    fontWeight: "bold",
                                }}
                            >
                                curățenie post-construcție
                            </a>{" "}
                            – acoperim întreaga proprietate, nu doar geamurile.
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={4}>
                            Înainte de orice intervenție facem obligatoriu o probă de curățare în
                            fața clientului, ca să verificăm împreună că sticla nu suferă.
                        </MKTypography>

                        <MKBox
                            component="img"
                            src="https://doral-cleaning.ro/static/media/6-5-galerie-postconstruct.fe284faba1d34b183488.webp"
                            alt="Indepartare murdarie și folii de protectie tamplaria geamurilor"
                            width="100%"
                            borderRadius="xl"
                            shadow="md"
                            mb={4}
                        />

                        <MKTypography variant="h3" mb={3} color="dark">
                            Tratamente speciale pentru suprafețe vitrate
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={4}>
                            Pentru clădiri comerciale sau fațade expuse constant la praf și
                            intemperii, oferim aplicarea de tratamente hidrofobe. Acestea creează o
                            barieră invizibilă pe suprafața sticlei, care face ca apa să se scurgă
                            rapid, antrenând și particulele de murdărie. Rezultatul? Geamurile se
                            murdăresc mult mai greu, iar următoarea curățare va fi mult mai ușoară
                            și mai rapidă.
                        </MKTypography>

                        <MKBox
                            component="img"
                            src="https://doral-cleaning.ro/static/media/9-9-vitrate.f4b0bbe59b2377e92f4a.webp"
                            alt="tratamente speciale suprafete vitrate decalcarizare hidrofob folie"
                            width="100%"
                            borderRadius="xl"
                            shadow="md"
                            mb={4}
                        />

                        <MKTypography variant="h3" mb={3} color="dark">
                            Curățare geamuri la înălțime pentru sedii de firmă și hale
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={2}>
                            Pe fațadele comerciale și industriale, înălțimea schimbă complet
                            ecuația.
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={2}>
                            Între 3 și 7 metri lucrăm cu structuri metalice și platforme electrice
                            autoridicătoare, atât la interior – compartimentări vitrate din{" "}
                            <a
                                href="https://doral-cleaning.ro/curatenie-birouri-firme-spatii-comerciale"
                                style={{
                                    textDecoration: "none",
                                    color: "#1A73E8",
                                    fontWeight: "bold",
                                }}
                            >
                                birouri și spații comerciale
                            </a>{" "}
                            – cât și la exterior, unde poluarea și condițiile meteo lasă depuneri
                            greu de abordat fără echipamente potrivite.
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={4}>
                            Spălarea finală se face prin jet de apă cu presiune sau prin osmoză
                            inversă, în funcție de suprafață și tipul de murdărie. Pentru
                            întreținerea curentă a fațadelor, curățarea prin periere cu osmoză
                            inversă sau cu drone cu jet de apă sunt soluții rapide, fără schele,
                            fără întreruperea activității.
                        </MKTypography>

                        <MKBox
                            component="img"
                            src="https://doral-cleaning.ro/static/media/9-8-vitrate.3112ebe90cd29706de4e.webp"
                            alt="curatare geamuri la inaltime fatade comerciale industriale"
                            width="100%"
                            borderRadius="xl"
                            shadow="md"
                            mb={4}
                        />

                        <MKTypography variant="h4" mb={2} color="dark">
                            Alpinism utilitar pentru suprafețe vitrate de peste 7 metri
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={2}>
                            Dincolo de 7 metri, platformele clasice nu mai ajung. Operatorii noștri
                            certificați în alpinism utilitar intervin pe orice punct al fațadei,
                            inclusiv zone retrase sau cu geometrii complicate.
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={4}>
                            Pentru{" "}
                            <a
                                href="https://doral-cleaning.ro/curatenie-fabrici-depozite-hale"
                                style={{
                                    textDecoration: "none",
                                    color: "#1A73E8",
                                    fontWeight: "bold",
                                }}
                            >
                                fabrici, depozite și hale
                            </a>{" "}
                            cu suprafețe vitrate extinse, aceasta este metoda prin care garantăm
                            acces complet și rezultat uniform pe toată fațada.
                        </MKTypography>

                        <MKTypography variant="h3" mb={3} color="dark">
                            Rezultate de durată și geamuri impecabile cu Doral Cleaning
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={2}>
                            Dacă vrei să știi că lucrarea e făcută cum trebuie – cu produse corecte,
                            cu oameni care știu ce fac și la un preț cinstit – suntem aici.
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={2}>
                            Doral Cleaning intervine cu echipe calificate și cu propriile
                            echipamente, indiferent dacă vorbim despre o fereastră de apartament sau
                            de fațada unei hale.
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={2}>
                            Un lucru pe care îl spunem mereu clienților: nu lăsați pe oricine să
                            umble pe geamurile voastre. Un burete abraziv, o spatulă de improvizație
                            sau un detartrant acid pot zgâria sticla sau distruge garniturile
                            ireversibil.
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={4}>
                            Dacă aveți depuneri de la constructor, cereți întotdeauna o probă de
                            curățare înainte de a da liber pe toată suprafața.
                        </MKTypography>

                        <MKTypography variant="h3" mb={3} color="dark">
                            Cere o ofertă personalizată!
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={2}>
                            Fiecare spațiu are nevoi diferite. Nu te mulțumi cu soluții standard.
                            Cere o ofertă personalizată astăzi și hai să vorbim concret despre
                            proiectul tău!
                        </MKTypography>
                        <MKTypography variant="body1" color="text">
                            Contactează-ne la telefon{" "}
                            <a
                                href="tel:0757093579"
                                style={{
                                    textDecoration: "none",
                                    color: "#1A73E8",
                                    fontWeight: "bold",
                                }}
                            >
                                0757 093 579
                            </a>
                        </MKTypography>
                    </Grid>
                </Grid>
            </Container>
        </MKBox>
    );
}

export default ArticleContent;
